import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, FormControlLabel } from '@mui/material';
import { updatetheme, themedata } from '../../../../store/theme_data';
import { useSelector } from 'react-redux';
import '../../../../cssfiles/homepage.css'
import { authorizecommand, setscheduler } from '../../../../Restclient/datacollection';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

export default function SchedulerWidget(props) {
  const theme = useSelector((state) => state.themedata.theme);
  const livedata = useSelector((state) => state.mainpagedata.livedata);

  const [taglistprops, setTaglistprops] = useState([])
  const [ctimearray, setCtimearray] = useState([])
  const [dialogflag, setDialogflag] = useState(false)
  const [dialogMessage, setDialogMessage] = useState("Schedule sent to device")
  const [authDialogFlag, setAuthDialogFlag] = useState(false)
  const [commandPassword, setCommandPassword] = useState("")
  const [authErrorMessage, setAuthErrorMessage] = useState("")
  const [consentChecked, setConsentChecked] = useState(false)
  const [pendingSchedulePayload, setPendingSchedulePayload] = useState(null)
  const [isAuthorizing, setIsAuthorizing] = useState(false)
  const [isLiveDataLoading, setIsLiveDataLoading] = useState(true)

  const defaultData = [
    // { tagname: 'Kitchen Area AC 1 - Schedule', displayname: 'Kitchen Area AC 1', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Kitchen Area AC 2 - Schedule', displayname: 'Kitchen Area AC 2', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Kitchen Area AC 3 - Schedule', displayname: 'Kitchen Area AC 3', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Lighting GF 1 - Schedule', displayname: 'Lighting GF 1', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Lighting FF - Schedule', displayname: 'Lighting FF', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Cold Room AC - Schedule', displayname: 'Cold Room AC', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Manager Room AC - Schedule', displayname: 'Manager Room AC', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Sign Board - Schedule', displayname: 'Sign Board', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Make Line - Schedule', displayname: 'Make Line', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Oven 1 - Schedule', displayname: 'Oven 1', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Oven 2 - Schedule', displayname: 'Oven 2', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Oven 3 - Schedule', displayname: 'Oven 3', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Dining Hall 1 (GF) AC - Schedule', displayname: 'Dining Hall 1 (GF) AC', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Dining Hall 2 (FF) AC 1 - Schedule', displayname: 'Dining Hall 2 (FF) AC 1', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Dining Hall 2 (FF) AC 2 - Schedule', displayname: 'Dining Hall 2 (FF) AC 2', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Exhaust Fan - Schedule', displayname: 'Exhaust Fan', config: { start: '08:00', stop: '17:00' } },
    // { tagname: 'Fresh Air Fan - Schedule', displayname: 'Fresh Air Fan', config: { start: '08:00', stop: '17:00' } }
  ];

  //const schedularData = props.widgetprop.props.extended.tagprops //&& props.widgetprop.props.extended.tagprops.length > 0 ? props.widgetprop.props.extended.tagprops : defaultData;

  /*const [times, setTimes] = useState(
    schedularData.map(schedular => ({
      start: schedular.config.start,
      stop: schedular.config.stop
    }))
  );*/

  //const [updatedData, setUpdatedData] = useState(schedularData);

  const rescallback = (res) => {
    console.log("res set scheduler ",res)
    if (res?.success === false || (res?.code && Number(res.code) >= 400)) {
      setDialogMessage(res?.message || "Failed to send schedule to device")
    } else {
      setDialogMessage("Schedule sent to device")
    }
    setDialogflag(true)

  }

  const buildSingleSchedulePayload = (index) => {
    var schedulerlist = []

    schedulerlist.push({
      "Device Name": ctimearray[index].name +" - Schedule",
      "Device UID": ctimearray[index].deviceid,
      "timestamp": (Number(Date.now())/1000).toFixed(0),
      "Data": {
        "SX.Sch.ON": ctimearray[index].settimestart,
        "SX.Sch.OFF": ctimearray[index].settimeend,
      }
    })

    return {
      gatewayid: props.widgetprop.props.extended.gatewayid,
      schedule: schedulerlist
    }
  }

  const buildAllSchedulePayload = () => {
    var schedulerlist = []
    for(let i=0; i<ctimearray.length; i++) {
      schedulerlist.push({
        "Device Name": ctimearray[i].name +" - Schedule",
        "Device UID": ctimearray[i].deviceid,
        "timestamp": (Number(Date.now())/1000).toFixed(0),
        "Data": {
          "SX.Sch.ON": ctimearray[i].settimestart,
          "SX.Sch.OFF": ctimearray[i].settimeend,
        }
      })
    }

    return {
      gatewayid: props.widgetprop.props.extended.gatewayid,
      schedule: schedulerlist
    }
  }

  const openAuthorizationDialog = (payload) => {
    setPendingSchedulePayload(payload)
    setCommandPassword("")
    setAuthErrorMessage("")
    setConsentChecked(false)
    setAuthDialogFlag(true)
  }

  const handleSetTime = (index) => {
    var payload = buildSingleSchedulePayload(index)
    openAuthorizationDialog(payload)
    console.log("payload ",JSON.stringify(payload))
    /*const newSchedularData = [...updatedData];
    newSchedularData[index].config.start = times[index].start;
    newSchedularData[index].config.stop = times[index].stop;
    setUpdatedData(newSchedularData);
    console.log(`Set time for index ${index}:`, times[index]);*/
  };

  const handleSetAllTimes = () => {
    var payload = buildAllSchedulePayload()
    openAuthorizationDialog(payload)
   
    /*const newSchedularData = updatedData.map((schedular, index) => ({
      ...schedular,
      config: {
        start: times[index].start,
        stop: times[index].stop
      }
    }));
    setUpdatedData(newSchedularData);
    console.log('Set all times:', times);*/
  };

  useEffect(() => {
    var taglist = props.widgetprop.props.extended.tagprops
    var tlist = []
    var clist = []
    for(let i=0; i<taglist.length; i++) {
      tlist.push({
        name: taglist[i].tagname,
        deviceid: taglist[i].deviceid,
        tagid: taglist[i].tagid,
        tagid1: taglist[i].tagid1,
        timestart: "",
        timeend: "",
        lastUpdated: ""
      })
      clist.push({
        name: taglist[i].tagname,
        deviceid: taglist[i].deviceid,
        tagid: taglist[i].tagid,
        tagid1: taglist[i].tagid1,
        settimestart: "",
        settimeend: ""
      })
    }
    setTaglistprops(tlist)
    setCtimearray(clist)
  },[])

  useEffect(() => {
    if(livedata.length && taglistprops.length) {
        var newtaglist = [...taglistprops]
        for(let i=0; i<livedata.length; i++) {
            for(let j=0; j<newtaglist.length; j++) {
              if(parseInt(newtaglist[j].tagid) === parseInt(livedata[i].TagId)) {
                  newtaglist[j].timestart = (parseInt(livedata[i].value/256) > 9 ?  parseInt(livedata[i].value/256) : "0"+parseInt(livedata[i].value/256)) + ":" + (parseInt(livedata[i].value%256) > 9 ?  parseInt(livedata[i].value%256) : "0"+ parseInt(livedata[i].value%256))
                  // Set last updated timestamp if available
                  if (livedata[i].timestamp) {
                    const date = new Date(livedata[i].timestamp * 1000);
                    newtaglist[j].lastUpdated = date.toLocaleString();
                  } else {
                    newtaglist[j].lastUpdated = "";
                  }
                  break
              }
              if(parseInt(newtaglist[j].tagid1) === parseInt(livedata[i].TagId)) {
                  if(livedata[i].value !== 30718) {
                    newtaglist[j].timeend = (parseInt(livedata[i].value/256) > 9 ?  parseInt(livedata[i].value/256) : "0"+parseInt(livedata[i].value/256)) + ":" + (parseInt(livedata[i].value%256) > 9 ?  parseInt(livedata[i].value%256) : "0"+ parseInt(livedata[i].value%256))
                  } else {
                    newtaglist[j].timeend = "20:00"
                  }
                  // Set last updated timestamp if available
                  if (livedata[i].timestamp) {
                    const date = new Date(livedata[i].timestamp * 1000);
                    newtaglist[j].lastUpdated = date.toLocaleString();
                  } else {
                    newtaglist[j].lastUpdated = "";
                  }
                  break
              }
            }
        }
        if(newtaglist.length) {
          setTaglistprops(newtaglist)
          setIsLiveDataLoading(false)
        }
    }
  },[livedata, taglistprops])

  const handleTimeChange = (index, type, value) => {
    const newTimes = [...ctimearray];
    newTimes[index][type] = value;
    setCtimearray(newTimes);
    console.log("newTimes ",newTimes)
  };

  const handleClosedialogdelete = () => {
    setDialogflag(false)
  }

  const handleCloseAuthDialog = () => {
    if (isAuthorizing) {
      return
    }
    setAuthDialogFlag(false)
    setCommandPassword("")
    setAuthErrorMessage("")
    setConsentChecked(false)
    setPendingSchedulePayload(null)
  }

  const handleAuthorizeAndSend = () => {
    if (isAuthorizing) {
      return
    }
    if (!pendingSchedulePayload) {
      setAuthErrorMessage("Unable to send command. Please try again.")
      return
    }
    if (!commandPassword.trim()) {
      setAuthErrorMessage("Password is required")
      return
    }
    if (!consentChecked) {
      setAuthErrorMessage("Please confirm the electrical safety consent before sending.")
      return
    }

    setIsAuthorizing(true)
    setAuthErrorMessage("")

    authorizecommand(commandPassword, (authRes) => {
      const commandToken = authRes?.commandToken || authRes?.data?.commandToken

      if (!commandToken) {
        const authError = Number(authRes?.code) === 401
          ? "Incorrect password. Please try again."
          : (authRes?.message || "Authorization failed. Please try again.")
        setAuthErrorMessage(authError)
        setIsAuthorizing(false)
        return
      }

      setscheduler(pendingSchedulePayload, (sendRes) => {
        const isForbidden = Number(sendRes?.code) === 403

        if (isForbidden) {
          setAuthErrorMessage(sendRes?.message || "Authorization expired. Please confirm password again.")
          setIsAuthorizing(false)
          return
        }

        setIsAuthorizing(false)
        setAuthDialogFlag(false)
        setCommandPassword("")
        setAuthErrorMessage("")
        setConsentChecked(false)
        setPendingSchedulePayload(null)
        rescallback(sendRes)
      }, commandToken)
    })
  }

  return (
    <Box sx={{ overflowY: 'auto', height: '83%', margin:'10px' }}>
      {isLiveDataLoading && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', gap: '10px' }}>
          <span style={{
            display: 'inline-block',
            width: '20px',
            height: '20px',
            border: '3px solid var(--LK_BrandBlue, #1976d2)',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'schedulerSpin 0.8s linear infinite',
          }} />
          <style>{`@keyframes schedulerSpin { to { transform: rotate(360deg); } }`}</style>
          <Typography style={{ color: 'var(--PrimaryText)', fontSize: '14px' }}>Loading data...</Typography>
        </Box>
      )}
      {!isLiveDataLoading && (
        <TableContainer>
        <Table>
          <TableHead >
            <TableRow >
              <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>Scheduler Name</TableCell>
              <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>Device Name</TableCell>
              <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>Start Time</TableCell>
              <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>Stop Time</TableCell>
              <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>Last Updated</TableCell>
              <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>Set Start Time</TableCell>
              <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>Set Stop Time</TableCell>
              <TableCell align="center">
                <button 
                    style={{
                        padding: '8px 20px',
                        backgroundColor: 'var(--LK_BrandBlue)',
                        color: 'var(--White)',
                        border: 'none',
                        borderRadius: '20px',
                        fontSize: '16px',
                        fontWeight: 700,
                        fontFamily: 'Roboto',
                        cursor: 'pointer',
                        marginRight: '10px'
                    }}
                    onClick={handleSetAllTimes}
                >
                    Set All
                </button>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {taglistprops.map((schedular, index) => (
              <TableRow key={index}>
                <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>{"Scheduler "+(index+1)}</TableCell>
                <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>{schedular.name}</TableCell>
                <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>{schedular.timestart}</TableCell>
                <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>{schedular.timeend}</TableCell>
                <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>{schedular.lastUpdated}</TableCell>
                <TableCell style={{color: 'var(--PrimaryText)', fontSize: '16px'}}>
                <input
                    type="time"
                    //value={times[index].start}
                    onChange={(e) => handleTimeChange(index, 'settimestart', e.target.value)}
                    style={{
                      //padding: '2px',
                      //borderRadius: '6px',
                      width: '100px',
                      textAlign: 'center',
                      fontFamily:'Roboto',
                      fontSize:'16px',
                      backgroundColor: theme === 'dark' ? '#2222' : '#fff',
                      color: theme === 'dark' ? '#fff' : '#000',
                      border: '1px solid',
                      borderColor: theme === 'light' ? '#2222' : '#fff',

                    }}
                  />
                </TableCell>
                <TableCell style={{color: 'var(--PrimaryText)'}}>
                <input
                    type="time"
                    //value={times[index].stop}
                    onChange={(e) => handleTimeChange(index, 'settimeend', e.target.value)}
                    style={{
                      //padding: '2px',
                      //borderRadius: '6px',
                      width: '100px',
                      textAlign: 'center',
                      fontFamily:'Roboto',
                      fontSize:'16px',
                      backgroundColor: theme === 'dark' ? '#2222' : '#fff',
                      color: theme === 'dark' ? '#fff' : '#000',
                      border: '1px solid #000',
                      borderColor: theme === 'light' ? '#2222' : '#fff',
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Button variant="text" color="primary" style={{textTransform: 'none'}} onClick={() => handleSetTime(index)}>Set</Button>
                </TableCell>
              </TableRow>
            ))}
      <Dialog
          open={authDialogFlag}
          onClose={handleCloseAuthDialog}
          aria-labelledby="command-auth-dialog-title"
          PaperProps={{ sx: { borderRadius: "0px" } }}
        >
          <DialogTitle id="command-auth-dialog-title" style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
            {"Confirm Password"}
          </DialogTitle>
          <DialogContent style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
            <Typography style={{marginBottom: '10px'}}>
              Re-enter your password to authorize this command.
            </Typography>
            <Typography style={{marginBottom: '10px', fontSize: '14px', color: theme === 'dark' ? '#FFD4D4' : '#8B0000'}}>
              Warning: This command controls electrical equipment. Confirm the site is safe and that switching operations will not endanger people, assets, or ongoing maintenance activity.
            </Typography>
            <TextField
              fullWidth
              type="password"
              size="small"
              value={commandPassword}
              onChange={(e) => setCommandPassword(e.target.value)}
              autoFocus
              onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleAuthorizeAndSend()
              }
              }}
              error={Boolean(authErrorMessage)}
              helperText={authErrorMessage}
            />
            <FormControlLabel
              style={{marginTop: '10px'}}
              control={
                <Checkbox
                  checked={consentChecked}
                  onChange={(e) => {
                    setConsentChecked(e.target.checked)
                    if (authErrorMessage === "Please confirm the electrical safety consent before sending.") {
                      setAuthErrorMessage("")
                    }
                  }}
                />
              }
              label="I understand the electrical risk and confirm it is safe to proceed with this switching command."
            />
          </DialogContent>
          <DialogActions style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
            <Button onClick={handleCloseAuthDialog} disabled={isAuthorizing}>Cancel</Button>
            <Button onClick={handleAuthorizeAndSend} variant="contained" disabled={isAuthorizing || !consentChecked}>
              {isAuthorizing ? 'Authorizing...' : 'Confirm & Send'}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={dialogflag}
          onClose={handleClosedialogdelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{ sx: { borderRadius: "0px" } }}
      >
          <DialogTitle id="alert-dialog-title" style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
              {"Info"}
          </DialogTitle>
          <DialogContent style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
              {dialogMessage}
          </DialogContent>
          <DialogActions style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
              <button 
                  style={{
                      padding: '6px 15px',
                      //width: '137px',
                      //height: '35px',
                      backgroundColor: 'transparent',
                      color: '#7E7E7E',
                      //padding: '8px 45px',
                      border: '1px solid',
                      borderColor:theme === 'dark' ? '#7E7E7E' : '#7E7E7E',
                      borderRadius: '20px',
                      fontSize: '16px',
                      fontWeight: 700,
                      fontFamily: 'Roboto',
                      cursor: 'pointer',
                      marginRight: '10px'
                  }}
                  onClick={handleClosedialogdelete}
              >
                  Close
              </button>
          </DialogActions>
      </Dialog>
</TableBody>
</Table>
        </TableContainer>
      )}
    </Box>
  );
}
